module.exports = __webpack_public_path__ + "static/assets/ec14005976de0c416291669942e660b9.png";